import { render, staticRenderFns } from "./ImportForm.vue?vue&type=template&id=8f482edc&lang=pug"
import script from "./ImportForm.vue?vue&type=script&lang=js"
export * from "./ImportForm.vue?vue&type=script&lang=js"
import style0 from "./ImportForm.vue?vue&type=style&index=0&id=8f482edc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports